// "Start from a past event": a new project built from an earlier one. Pure, so tests/unit/copy-project.test.mjs can
// check it; the page (pages/copy-project.js) also copies the linked on-site schedules and passes their new ids in.
//   Budget: the same sections and lines, with quantities, prices, currencies, VAT, markup, suppliers and notes;
//           every line back to TBC, nothing spent or billed (invoices and quotes stay with the old project).
//   Sub-budgets: copied, still planned against the copied main lines.
//   Deadlines: moved by the gap between the two event dates, none ticked off.
//   Crew: names and roles only; no travel, hotels, contact details or personal needs.
// Not copied: the old project's locked rates, Drive folder, linked tenders, expenses, resourcing and who it is shared with.
import { rid } from './sync.js';

import { dayGap, shiftDate } from './dates.js';

export function copyProject(src, { name, client, date, scheduleIds = [], now = Date.now() } = {}) {
  const shift = dayGap(src.date, date);
  const lineIds = new Map();
  let row = 0;
  const sections = (src.sections || []).map(s => ({
    id: rid('sec_'), name: s.name || '', _headerRow: ++row,
    items: (s.items || []).map(it => {
      const lineId = 'L' + rid('').slice(0, 10);
      if (it.lineId) lineIds.set(it.lineId, lineId);
      return { ...it, id: rid('it_'), lineId, _sheetRow: ++row, st: 'TBC', ag: null, ab: null };
    })
  }));
  const subBudgets = (src.subBudgets || []).map(sb => ({
    ...sb, id: rid('sb_'),
    lines: (sb.lines || []).map(l => ({ ...l, id: rid('sl_'), target: lineIds.get(l.target) || '' }))
  }));
  const deadlines = (src.deadlines || []).map(({ doneAt, doneBy, ...d }) => ({ ...d, id: rid('dl_'), date: shiftDate(d.date, shift), done: false }));
  const crew = (src.crew || []).filter(c => c.name).map(c => ({ id: 'cr_' + rid('').slice(0, 8), name: c.name, role: c.role || '' }));
  return {
    id: rid('p_'), name: name || `${src.name || 'Event'} (copy)`, client: client ?? src.client ?? '', date: date || '', status: 'Planning',
    costCcy: src.costCcy, billCcy: src.billCcy, sections, subBudgets, deadlines, crew, expenses: [],
    links: scheduleIds.length ? { schedule: scheduleIds } : {},
    copiedFrom: { id: src.id, name: src.name || '' }, createdAt: now, _seq: row
  };
}
